import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Church, Users, Building2, Settings, X } from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Dashboard', to: '/admin', icon: LayoutDashboard, end: true },
  { label: 'Documents', to: '/admin/documents', icon: FileText },
  { label: 'Church Reports', icon: Church, comingSoon: true },
  { label: 'Ministry Reports', icon: Users, comingSoon: true },
  { label: 'District Reports', icon: Building2, comingSoon: true },
  { label: 'Settings', icon: Settings, comingSoon: true },
];

export default function AdminSidebar({ open, onClose }) {
  return (
    <>
      {/* Mobile overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/50 z-30 md:hidden"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <aside
        className={`fixed md:static z-40 top-0 left-0 h-full w-64 bg-[#00323F] flex flex-col transform transition-transform duration-200 ease-in-out
          ${open ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0`}
      >
        {/* Branding */}
        <div className="flex items-center justify-between px-5 py-6 border-b border-white/10">
          <div className="flex items-center gap-2.5 min-w-0">
            <div className="h-8 w-8 rounded-md bg-[#4EA6B3] flex items-center justify-center shrink-0">
              <span className="text-white text-xs font-bold">WC</span>
            </div>
            <div className="min-w-0">
              <p className="text-white text-sm font-semibold leading-tight truncate">
                District Nazarene
              </p>
              <p className="text-white/40 text-[11px] leading-tight">Admin Portal</p>
            </div>
          </div>
          <button onClick={onClose} className="md:hidden text-white/60 hover:text-white shrink-0">
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-5 space-y-0.5">
          <p className="px-3 pb-2 text-[10px] font-semibold uppercase tracking-wider text-white/30">
            Main
          </p>
          {NAV_ITEMS.map((item) => {
            const Icon = item.icon;
            if (item.comingSoon) {
              return (
                <div
                  key={item.label}
                  className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-white/30 cursor-not-allowed select-none"
                  title="Coming later"
                >
                  <span className="flex items-center gap-3">
                    <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
                    {item.label}
                  </span>
                  <span className="text-[9px] uppercase tracking-wide border border-white/15 rounded px-1.5 py-0.5">
                    Soon
                  </span>
                </div>
              );
            }
            return (
              <NavLink
                key={item.label}
                to={item.to}
                end={item.end}
                onClick={onClose}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors ${
                    isActive
                      ? 'bg-[#007A96]/20 text-white font-medium border-l-2 border-[#4EA6B3] pl-[10px]'
                      : 'text-white/60 hover:bg-white/5 hover:text-white font-normal'
                  }`
                }
              >
                <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="px-5 py-4 border-t border-white/10">
          <p className="text-[11px] text-white/30 leading-relaxed">
            Western Cape District Administration
          </p>
        </div>
      </aside>
    </>
  );
}
